/**
 * Landing — /
 *
 * Public entry point of the lite funnel.
 * Hero + CTA button → /valuation.
 * Three feature bullets.
 * Footer link → /login.
 */

import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Landing.css';

const FEATURES = [
  '11-method analysis — the same framework professional brokers use',
  'Risk-adjusted multiples that reflect your real strengths and weaknesses',
  'Private — your results are emailed only to you',
];

function Landing() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <header className="landing-brandbar">
        <span className="landing-wordmark">Exit Ready</span>
      </header>
      <main className="landing-hero">
        <h1 className="landing-headline">What is your business worth?</h1>
        <p className="landing-subheadline">
          Know what your business is worth today — and what it takes to be
          exit-ready. A broker-grade estimate across 11 valuation methods,
          in about 10 minutes. Free.
        </p>

        <button
          className="landing-cta"
          onClick={() => navigate('/valuation')}
        >
          Get my free valuation
        </button>

        <ul className="landing-features">
          {FEATURES.map((feature) => (
            <li key={feature} className="landing-feature-item">
              <span className="landing-feature-check" aria-hidden="true">
                &#10003;
              </span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </main>

      <footer className="landing-footer">
        <Link to="/login">Already have an account? Sign in</Link>
      </footer>
    </div>
  );
}

export default Landing;
